/**
 * Returns the initial, top-level comment of a pendency.  New pendencies mirror
 * their initial observation to this comment so it can be displayed in cards.
 */
export const getInitialPendencyComment = (pendency) => {
    const rootComments = pendency?.comments?.filter(comment => !comment.parentId) || [];

    if (rootComments.length === 0) return null;

    return [...rootComments].sort(
        (first, second) => new Date(first.createdAt).getTime() - new Date(second.createdAt).getTime()
    )[0];
};

/**
 * Uses the same source of truth as the pendency card, with the legacy field as
 * a fallback for records created before comments were introduced.
 */
export const getPendencyObservationText = (pendency) =>
    getInitialPendencyComment(pendency)?.text ?? pendency?.observacoes ?? '';

/**
 * Keeps the editable initial observation and the comment rendered on cards in
 * sync. A comment is created only when a legacy-only record's text is changed.
 */
export const syncInitialPendencyComment = (pendency, text, author) => {
    const comments = Array.isArray(pendency?.comments) ? pendency.comments : [];
    const initialComment = getInitialPendencyComment(pendency);

    if (initialComment) {
        return comments.map(comment => (
            (comment.id && comment.id === initialComment.id) ||
            (!comment.id && comment.createdAt === initialComment.createdAt)
                ? { ...comment, text }
                : comment
        ));
    }

    return [
        ...comments,
        {
            id: Math.random().toString(36).substring(2, 11),
            text,
            author,
            createdAt: new Date().toISOString(),
            parentId: null
        }
    ];
};
